import React from "react";

const Column = ({ children, style, className }) => {
  return <div className={className} style={style}> {children} </div>;
};

export default Column;
